import { Box, Paper, Stack, styled, Typography, Grid, InputAdornment } from '@mui/material';
import { Colors, ColorsV2 } from '../constants/color';

const MainContainer = styled(Box)({
  width: '94.5%',
  marginTop: '6%',
  marginLeft: '10px',
  height: '90%',
  padding: '20px 25px 25px 15px',
});

const Title = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 700,
  fontSize: '1em',
  textTransform: 'uppercase',
  color: ColorsV2.white,
});

const Container = styled(Paper)({
  width: '100%',
  padding: '0.4em 2em 0.9em 2em',
  boxSizing: 'border-box',
  marginTop: '1.2em',
  borderRadius: '0',
});

const SubTitle = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 700,
  fontSize: '0.9em',
  lineHeight: '26.04px',
  letterSpacing: '0.1px',
  color: '#1C1D21',
});

const SubTitleText = styled(Typography)({
  fontFamily: 'DM Sans, sans-serif',
  fontWeight: 400,
  fontSize: '0.7em',
  lineHeight: '21px',
  color: Colors.pageHeading_icon,
  marginTop: '0.7em',
});

const ParentGrid = styled(Grid)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
});
const ChildGrid = styled(Grid)({
  width: '45%',
  display: 'flex',
  alignItems: 'end',
  flexDirection: 'column',
});

const SubConatiner = styled(Box)({
  borderBottom: `1px solid #E2E2EA`,
  padding: '0.8em 0px',
  width: '100%',
});

const SubConatiner2 = styled(Box)({
  width: '100%',
});

const SubConatiner3 = styled(Box)({
  width: '100%',
  padding: '0.8em 0px',
});

const SubTitle2 = styled(Typography)({
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 500,
  fontSize: '0.7em',
  lineHeight: '21px',
  letterSpacing: '0.1px',
  color: '#1C1D21',
});

const ContainerStack = styled(Stack)({
  borderBottom: '1px solid #E2E2EA',
  padding: '0.8em 0px',
  width: '100%',
});

const SelectConatiner = styled(Box)({
  height: '100%',
  width: '10vw',
  display: 'flex',
  alignItems: 'center',
  marginTop: '0.2em',
  justifyContent: 'flex-end',
});

const InputContainerStack = styled(Stack)({
  width: '100%',
  borderBottom: '1px solid #E2E2EA',
  padding: '0px 0px 0.7em 0px',
});

const CustomAdornment = styled(InputAdornment)({
  fontFamily: 'DM Sans, sans-serif',
  margin: '0px 0.2em 0px 0px',
  fontSize: '0.7em',
  fontWeight: '400',
  lineHeight: '21px',
});
const CustomAdornment2 = styled(InputAdornment)({
  fontFamily: 'DM Sans, sans-serif',
  margin: '0px 5px 0px 0px',
  fontSize: '0.7em',
  fontWeight: '400',
  lineHeight: '21px',
  color: '#000000',
});

const TitleContainer = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export {
  MainContainer,
  Title,
  Container,
  SubTitle,
  SubTitleText,
  ParentGrid,
  ChildGrid,
  SubConatiner,
  SubConatiner2,
  SubConatiner3,
  SubTitle2,
  ContainerStack,
  SelectConatiner,
  InputContainerStack,
  CustomAdornment,
  TitleContainer,
  CustomAdornment2,
};
